<template>
  <tr>
    <td
      v-for="(config, dataKey) in columnConfig"
      :key="dataKey"
      class="column result-table__column"
      :class="{'result-table__column--hidden': !config.visible, 'result-table__column--comment': dataKey === 'comments'}" @click="openDetails(result.uuid)">
      <span>{{ getColumnValue(result, dataKey) }}</span>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { ISearchResultItem } from '@/interfaces/search/ISearchResultItem';
import { useRouter } from 'vue-router';
import { useUtil } from '@/services/util-service';

const router = useRouter();

 defineProps({
  result: {} as PropType<ISearchResultItem>,
  columnConfig: {} as PropType<Record<string, { displayName: string; visible: boolean }>>,
});

const getColumnValue = (result: ISearchResultItem | undefined, dataKey: string): string | number | string [] => {
  if (!result) {
    return "";
  }

  var value = result[dataKey];
  if (dataKey === "length" || dataKey === "width") {
    return value ? `${useUtil().formatNumber(value)} meter` : "";
  }

  // get array values as comma-separated string
  if (Array.isArray(value)) {
    return value.join(", ");
  }

  return value ? value : "";
};

const openDetails = (shipId: string | undefined) => {
  if (!shipId) {
    return;
  }

  router.push({ name: 'Details', params: { shipId: shipId } });
}

</script>
